// biome-ignore lint/style/noRestrictedImports: encapsulation
import { isStrictEqual as isStrictEqual_ } from "remeda";

import type { NeverFunc } from "./_never-func";
import { unpurry } from "./_unpurry";

export const isStrictEqual = unpurry(isStrictEqual_, 2) as typeof isStrictEqual_ & NeverFunc;
